import { biStrategy } from './biStrategy/biStrategy';
import urlResolutionStrategy from './urlResolutionStrategy/urlResolutionStrategy';
import pollsStrategy from './pollsStrategy/pollsStrategy';
import mapStrategy from './mapStrategy/mapStrategy';
import iframeSandboxDomainStrategy from './iframeSandboxDomainStrategy/iframeSandboxDomainStrategy';
import { merge } from 'lodash';
import { parseInstance, hasPlugin as hasPluginInPlugins, hasPollsPluginInContent, } from './services';
import { POLL_TYPE, MAP_TYPE } from 'wix-rich-content-common';
var getHttpClientPromise;
var httpClientPromise;
export var runStrategies = function (_a) {
    var _b;
    var _c = _a.experiments, experiments = _c === void 0 ? {} : _c, plugins = _a.plugins, instance = _a.instance, wixRicosVersion = _a.wixRicosVersion, biSettings = _a.biSettings, httpClient = _a.httpClient, _d = _a.msid, msid = _d === void 0 ? '' : _d, _e = _a.viewer, viewer = _e === void 0 ? false : _e, content = _a.content;
    var hasPlugin = function (pluginType) { return hasPluginInPlugins(pluginType, plugins); };
    var _f = parseInstance(instance), instanceMsid = _f.metaSiteId, appDefId = _f.appDefId;
    var metaSiteId = instanceMsid || msid;
    getHttpClientPromise = function () {
        if (!httpClientPromise)
            httpClientPromise =
                (httpClient && Promise.resolve(httpClient)) ||
                    import('@wix/http-client').then(function (http) { return new http.HttpClient(); });
        return httpClientPromise;
    };
    var ricosFeatures = experiments.ricosFeatures, wixRicosFeatures = experiments.wixRicosFeatures;
    var shouldUsePollStrategy = hasPlugin(POLL_TYPE) && (!viewer || (viewer && hasPollsPluginInContent(content)));
    return merge({ experiments: ricosFeatures }, biStrategy(appDefId, metaSiteId, wixRicosVersion, biSettings, wixRicosFeatures), urlResolutionStrategy(hasPlugin, instance, metaSiteId, wixRicosFeatures), shouldUsePollStrategy && pollsStrategy(instance, getHttpClientPromise, wixRicosFeatures), iframeSandboxDomainStrategy(metaSiteId, wixRicosFeatures), ((_b = wixRicosFeatures === null || wixRicosFeatures === void 0 ? void 0 : wixRicosFeatures.mapStrategy) === null || _b === void 0 ? void 0 : _b.enabled) && hasPlugin(MAP_TYPE) && mapStrategy());
};
export var runStrategiesWithCommonUtils = function (props) { return ({
    strategies: runStrategies(props),
    getHttpClientPromise: getHttpClientPromise,
}); };
//# sourceMappingURL=runStrategies.js.map